import React from 'react';
import styles from './Accordion.module.scss';

export interface AccordionProps {
  sections: {title: string; content: React.ReactNode}[];
}

export default function Accordion({sections}: AccordionProps) {
  const accordionContent = sections.map(({title, content}) => (
    <div className={styles.Section} key={`AccordionSection-${title}`}>
      <div className={styles.Header}>
        <h2 className={styles.HeaderContent}>{title}</h2>
      </div>
      <div className={styles.SectionContent}>{content}</div>
    </div>
  ));

  return <div className={styles.Accordion}>{accordionContent}</div>;
}
